<template>
    <div>
        <div><i class="material-icons">sentiment_very_dissatisfied</i></div>
        <h3>Ble det for dyrt?</h3>
        <div style="text-align: left">
        <!--
        <p>Visste du at din forsikring ofte kan dekke slike skader? Dette kan vi hjelpe deg med å avklare. Ønsker du at vi tar kontkt med deg om dette?</p>
        -->
            <p>Vurderer du å bruke din forsikring? Det kan være at dette ikke går utover din bonus eller gir deg egenandel. La oss sjekke dette for deg mot ditt forsikringsselskap.</p>
            <p>Velg ditt forsikringsselkap:</p>
        </div>
        <div class="inputWrap">
            <v-select placeholder="Forsikringsselskap" v-model="insurance_company" label="name" :options="insurance_companies"></v-select>
            <span class="v-error" v-if="localErrors.insurance_company" v-text="localErrors.insurance_company"></span>
        </div>
        <div class="actions">
            <div>
                <button @click.prevent="send('reject')">Nei</button>
            </div>
            <div>
                <button @click.prevent="send('reconsider')"><!-- Ja takk! -->Ja, ta kontakt</button>
            </div>
        </div>
        <div class="mpsCancelBtn" @click.prevent="close()"><i class="material-icons">close</i></div>
    </div>
</template>

<script>

    import VuejsDialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js'; // only needed in custom components

    export default {
        data () {
            return {
                id_company_current: null,
                id_company: null,
                insurance_companies: [],
                validate: false
            }
        },
        mixins: [VuejsDialogMixin],
        computed: {
            insurance_company: {
                get: function () {
                    for (var i = 0; i < this.insurance_companies.length; i++) {
                        var insurance_company = this.insurance_companies[i];
                        if(insurance_company.id == this.id_company)
                            return insurance_company
                    }
                    return null
                },
                set: function (insurance_company) {
                    if(insurance_company)
                        this.id_company = insurance_company.id
                    else
                        this.id_company = null
                }
            },
            localErrors(){
                if(this.validate){
                    var e = {};
                    if(!this.insurance_company) {
                        e.insurance_company = 'Please select insurance company';
                    }
                    return e;
                }else{
                    return {};
                }
            }
        },
        methods: {
            send(res){
                if(res == 'reconsider' && !this.validateChanges()) return;
                this.proceed( {
                    result: res,
                    id_company: this.id_company
                });
            },
            validateChanges(){
                this.validate = true;

                if(Object.keys(this.localErrors).length)
                    return false;

                return true;
            },
        },
        created(){
            this.insurance_companies = this.$options.propsData.options.insurance_companies;
            this.id_company_current = this.$options.propsData.options.id_company;
            this.id_company = this.$options.propsData.options.id_company;
        }
    }
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// RejectOffer.vue?411d8d5e